import { Injectable } from '@angular/core';
import { Api } from '../../core/api';
import { RESOURCES } from '../../core/resources';
import { ApiService } from '../../core/apiService';
import { Limit } from '../../model/limit';

@Injectable()
export class LimitsService extends ApiService<Limit> {

  constructor(protected api: Api) {
    super(api);
    this.resource = RESOURCES.limits;
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/resources/limits/limits.service.ts